import { parseAsStringLiteral, useQueryState } from 'nuqs';

export const ASSIGNMENT_INFO_VALUES = ['info', 'statistics'];
// export const ASSIGNMENT_INFO_VALUES = ['statistics'];

const AssignmentTabs = () => {
  const [activeTab, setTab] = useQueryState(
    'tab',
    parseAsStringLiteral(ASSIGNMENT_INFO_VALUES).withDefault('info'),
  );

  return (
    <div className="bg-white rounded-t-xl shadow-sm border border-gray border-b-0 overflow-hidden">
      <div className="flex">
        <button
          type="button"
          key={'info'}
          onClick={() => setTab('info')}
          className={`flex-1 px-8 py-4 text-sm font-medium border-r border-gray last:border-r-0 transition-colors ${
            activeTab === 'info'
              ? 'bg-[hsl(226,64%,33%)] text-white border-b-1'
              : 'bg-white text-gray-600 hover:bg-gray-50 hover:text-dark'
          }`}
        >
          제출답안 / 정답 & 해설
        </button>
        <button
          type="button"
          key={'statistics'}
          onClick={() => setTab('statistics')}
          className={`flex-1 px-8 py-4 text-sm font-medium border-r border-gray last:border-r-0 transition-colors ${
            activeTab === 'statistics'
              ? 'bg-[hsl(226,64%,33%)] text-white border-b-1'
              : 'bg-white text-gray-600 hover:bg-gray-50 hover:text-dark'
          }`}
        >
          과제 통계
        </button>
      </div>
    </div>
  );
};

export default AssignmentTabs;
